import React, { Component } from 'react';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import onClickOutside from 'react-onclickoutside'

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
@onClickOutside
export default class Tip extends Component  {

  @observable trans = { };

  constructor(props) {
    super(props);
   // this.trans = this.props.dictionaryStorage.getCurrentLangDict;
  }

  handleClickOutside = evt => {
    this.props.handleClickOutside(evt);
  }

  render() {

 //   const t = this.t;

    return (
      <div className={"Tip "+(this.props.tipPosition ? 'Tip-'+this.props.tipPosition : '')} style={this.props.style}>
        {this.props.children}
      </div>
    );
  }
}


